
















































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import VerkInvoiceItemList from "./VerkInvoiceItemList.vue";
import { ColumnType } from "@/components/apiSearch/models/ApiSearch";
import { verkInvoiceStatusColor } from "./verkInvoiceStatus";

interface Props {
  /** Vezérrekord azonosító (hmifcapiverkinv.szam) */
  headId: number;
}

interface Methods {
  statusColor(status: number): string;
}

interface Computed {
  url: string;
  apiSearchName: string;
  columns: any[];
}

/**
 * Egy Verk vezérrekord kontírozás fejei (hmifcapiverkacc) — a háromszintű Verk lista 2. szintje.
 * Minden sor egy Verk bizonylat, saját státusszal és hibaüzenettel; a sor lenyitva a tételeit mutatja.
 */
export default Vue.extend<{}, Methods, Computed, Props>({
  name: "VerkInvoiceAccList",

  components: {
    ApiSearchPage,
    IconButton,
    DateTimeDisplay,
    SyncStatusBadge,
    VerkInvoiceItemList,
  },

  props: {
    headId: { type: Number, required: true },
  },

  computed: {
    url(): string {
      return `iface-sync-verk-invoice/acc-search/${this.headId}`;
    },

    /** Vezérrekordonként egyedi név — az ApiSearchPage eventBus-csatornái globálisak. */
    apiSearchName(): string {
      return `VerkInvoiceAccApiSearch_${this.headId}`;
    },

    columns(): any[] {
      return [
        { field: "command", title: "", cell: "command", filterable: false, sortable: false, width: 50 },
        { field: "accType", title: "Napló", width: 60, cell: "disabledText" },
        { field: "recType", title: "Biz. típus", width: 80, cell: "disabledText" },
        { field: "receiptNo", title: "Bizonylatszám", width: 150, cell: "disabledText" },
        { field: "dcFlag", title: "T/J", width: 50, cell: "disabledText" },
        { field: "glAccNo", title: "Főkönyvi szám", width: 110, cell: "disabledText" },
        { field: "costCenter", title: "Költséghely", width: 100, cell: "disabledText" },
        { field: "projectNo", title: "Projekt / jármű", width: 110, cell: "disabledText" },
        { field: "currency", title: "Pénznem", width: 70, cell: "disabledText" },
        { field: "exchRate", title: "Árfolyam", width: 80, type: ColumnType.Money, filterable: false },
        { field: "grossAmount", title: "Bruttó (dev.)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "grossAmountHuf", title: "Bruttó (HUF)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "statusName", title: "Státusz", width: 140, cell: "statusName", filterable: false },
        { field: "errMsg", title: "Hibaüzenet", width: 220, cell: "disabledText", fieldClass: "error-text-col" },
        { field: "insDateTime", title: "Rögzítve", width: 110, filterable: false, cell: "insDateTime" },
      ];
    },
  },

  methods: {
    statusColor(status) {
      return verkInvoiceStatusColor(status);
    },
  },
});
